var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDivitMilesIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64.187,
    height: 20.024,
    viewBox: "0 0 64.187 20.024",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_26118",
    "data-name": "Group 26118",
    transform: "translate(-9622.977 -12.926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26117",
    "data-name": "Group 26117",
    transform: "translate(9622.977 12.926)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_37446",
    "data-name": "Path 37446",
    d: "M620.606,193.653l-.3,3.337.3,3.337,2.89-1.669,2.89-1.669-2.594-1.965Z",
    transform: "translate(-614.826 -180.304)",
    fill: "#f93",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37447",
    "data-name": "Path 37447",
    d: "M644.3,179.974l-.3,3.337.3,3.337,2.89-1.669,2.89-1.669-2.594-1.965Z",
    transform: "translate(-632.738 -169.962)",
    fill: "#c00",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37448",
    "data-name": "Path 37448",
    d: "M644.3,159.291l-.3-3.337.3-3.337,2.89,1.669,2.89,1.669-2.594,1.965Z",
    transform: "translate(-632.738 -149.279)",
    fill: "#609",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37449",
    "data-name": "Path 37449",
    d: "M645.217,169.633l2.89-1.669L651,166.3v6.675l-2.89-1.669Z",
    transform: "translate(-633.656 -159.621)",
    fill: "#909",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37450",
    "data-name": "Path 37450",
    d: "M620.606,145.612l-.3-3.337.3-3.337,2.89,1.669,2.89,1.669-2.594,1.965Z",
    transform: "translate(-614.826 -138.937)",
    fill: "#03c",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37451",
    "data-name": "Path 37451",
    d: "M621.524,155.954l2.89-1.669,2.89-1.669v6.675l-2.89-1.669Z",
    transform: "translate(-615.744 -149.279)",
    fill: "#009",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37452",
    "data-name": "Path 37452",
    d: "M597.831,147.284h5.78v-8.347l-2.89,1.669-2.89,1.669",
    transform: "translate(-597.831 -138.937)",
    fill: "#09f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37453",
    "data-name": "Path 37453",
    d: "M597.831,186.8h5.78v8.347l-2.89-1.669-2.89-1.669Z",
    transform: "translate(-597.831 -175.122)",
    fill: "#fc3",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37454",
    "data-name": "Path 37454",
    d: "M621.524,183.312l2.89,1.669,2.89,1.669v-6.675l-2.89,1.669Z",
    transform: "translate(-615.744 -169.962)",
    fill: "#f63",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37455",
    "data-name": "Path 37455",
    d: "M688.868,169.894v-5.051c0-1.244-.651-2.373-1.933-2.373a2.153,2.153,0,0,0-2.009,2.373v5.051h-2.335v-9.452h2.162l.172,1.148a2.733,2.733,0,0,1,2.487-1.3,2.827,2.827,0,0,1,2.794,1.76,3.416,3.416,0,0,1,3.157-1.722c2.679,0,4,1.645,4,4.477v5.09H695.03V164.8c0-1.244-.517-2.3-1.78-2.3a2.147,2.147,0,0,0-2.047,2.335v5.051Z",
    transform: "translate(-661.913 -155.08)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37456",
    "data-name": "Path 37456",
    d: "M752.632,145.869a1.378,1.378,0,0,1-2.755,0A1.378,1.378,0,0,1,752.632,145.869Zm-2.545,2.621v9.472h2.334V148.49Z",
    transform: "translate(-712.782 -143.147)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37457",
    "data-name": "Path 37457",
    d: "M770.25,144.838v13.375h-2.316V144.838Z",
    transform: "translate(-726.434 -143.398)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37458",
    "data-name": "Path 37458",
    d: "M785.5,165.654c.153,1.167,1.167,2.009,2.813,2.009a3.892,3.892,0,0,0,2.526-.88l1.492,1.473a5.794,5.794,0,0,1-4.056,1.531c-3.253,0-5.185-2.009-5.185-5.032a4.72,4.72,0,0,1,5.013-4.937c3.157,0,5.128,1.952,4.764,5.836Zm5.128-1.933a2.161,2.161,0,0,0-2.449-1.837,2.541,2.541,0,0,0-2.64,1.837Z",
    transform: "translate(-737.891 -154.724)",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37459",
    "data-name": "Path 37459",
    d: "M833.093,162.67a3.181,3.181,0,0,0-2.334-.842c-1.11,0-1.722.344-1.722.938,0,.612.555.957,1.76,1.033,1.78.115,4.038.517,4.038,3.023,0,1.665-1.359,3.1-4.057,3.1a5.521,5.521,0,0,1-4.363-1.684l1.148-1.665a5.174,5.174,0,0,0,3.253,1.32c.88.019,1.7-.44,1.7-1.129,0-.65-.536-.918-1.875-.995-1.779-.134-3.9-.784-3.9-2.927,0-2.181,2.258-2.947,3.98-2.947a5.067,5.067,0,0,1,3.674,1.244Z",
    transform: "translate(-770.647 -154.783)",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivitMilesIconText);
export default __webpack_public_path__ + "static/media/divit-miles-icon-text.6288cd2d976629a11663563a97ac5734.svg";
export { ForwardRef as ReactComponent };